// import "jquery";
import Router from "./util/Router";

import common from "./routes/common";

import blog from "./routes/blog";

import pageTemplateResources from "./routes/resources";

const date = blog;
const category = blog;

const routes = new Router({
    common,
    blog,
    date,
    category,
    pageTemplateResources
});

function ready(func) {
    if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
        func(); 
    } else {
        document.addEventListener("DOMContentLoaded", func);
    }
}

ready(function () {
    routes.loadEvents();
});



// WEBPACK FOOTER //
// ./js/main.js